
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.526 1.744C17.534.58 15.359 0 13 0S8.466.581 6.474 1.744a12.945 12.945 0 00-4.73 4.73C.58 8.468 0 10.643 0 13.002c0 2.629.716 5.016 2.15 7.16 1.433 2.144 3.311 3.73 5.636 4.756-.045-1.207.028-2.206.22-2.996l1.676-7.075c-.282-.553-.423-1.242-.423-2.066 0-.959.243-1.76.728-2.403.485-.644 1.078-.965 1.777-.965.564 0 1 .186 1.304.558.305.373.457.841.457 1.405 0 .35-.065.777-.194 1.278-.13.503-.3 1.084-.508 1.744a21.34 21.34 0 00-.449 1.583c-.158.688-.028 1.278.39 1.769.417.49.97.736 1.658.736 1.208 0 2.198-.671 2.971-2.014.773-1.343 1.16-2.974 1.16-4.893 0-1.478-.477-2.68-1.43-3.605-.954-.925-2.283-1.388-3.987-1.388-1.907 0-3.45.612-4.63 1.836-1.179 1.225-1.769 2.69-1.769 4.393 0 1.015.288 1.868.864 2.556.191.226.254.468.186.728a9.368 9.368 0 00-.136.507c-.067.27-.112.446-.135.525-.09.361-.305.474-.643.339-.87-.361-1.53-.988-1.981-1.88-.451-.89-.677-1.923-.677-3.097 0-.756.121-1.512.364-2.268A7.735 7.735 0 015.713 8.03a8.914 8.914 0 011.845-1.87c.717-.542 1.589-.976 2.616-1.304a10.878 10.878 0 013.318-.49c1.602 0 3.041.355 4.316 1.066 1.275.711 2.249 1.63 2.92 2.76a6.968 6.968 0 011.008 3.622c0 1.693-.294 3.216-.88 4.57-.588 1.355-1.417 2.418-2.49 3.191-1.072.773-2.29 1.16-3.656 1.16a4.01 4.01 0 01-1.93-.483c-.598-.321-1.01-.702-1.235-1.142a591.548 591.548 0 01-.915 3.571c-.214.802-.654 1.727-1.32 2.777 1.207.36 2.438.541 3.69.541 2.359 0 4.534-.581 6.526-1.743a12.946 12.946 0 004.731-4.732c1.162-1.992 1.744-4.167 1.744-6.526 0-2.358-.582-4.533-1.744-6.525a12.951 12.951 0 00-4.731-4.73z"}})])
          )
        }
      }
    